import { render, staticRenderFns } from "./HeaderSupportButton.vue?vue&type=template&id=adec2202"
import script from "./HeaderSupportButton.vue?vue&type=script&lang=js"
export * from "./HeaderSupportButton.vue?vue&type=script&lang=js"
import style0 from "./HeaderSupportButton.vue?vue&type=style&index=0&id=adec2202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports